<bootstrap-popup [id]="id" [title]="popupTitle" [displaySubject]="displaySubject">
	<form role="form" class="form-horizontal">
		<div class="row">
			<div class="col-md-12 coactivites">
				<p *ngFor="let coactivite of coactivites">
					<span [ngClass]="{'self-coactif': coactivite.acces.raisonConflit === 'self'}">
						Acc&egrave;s
						<i>{{ coactivite.acces.accesCegex ? 'CEGEX ' : '' }}</i>
						{{ coactivite.acces.numero }} sur ouvrage
						{{ coactivite.acces.raisonConflit !== 'self' ? ' ' + coactivite.acces.raisonConflit : '' }} {{ coactivite.acces.commentaire }} 
						({{ coactivite.acces.typeAcces ? 'distant' : 'local' }})
						{{ coactivite.typeLabel ? ' - ' + coactivite.typeLabel : '' }}
					</span>
				</p>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<div class="form-group text-center">
					<button [disabled]="isCc && !isCac"
						type="button" class="btn btn-success" style="margin-right: 10px" 
						(click)="onAuthorizeRequested()">
						Autoriser l'acc&egrave;s
					</button>
					<button *ngIf="isCc && !isCac"
						type="button" class="btn btn-success" style="margin-right: 10px" (click)="onValidationRequested()">
						Demander une validation
					</button>
					
					<button
						type="button"
						class="btn btn-danger"
						style="margin-right: 6px"
						(click)="onDenyRequested()"
						>
						Refuser l'acc&egrave;s pour coactivit&eacute;
					</button>
					<button
						type="button"
						class="btn btn-primary"
						style="margin-right: 6px"
						(click)="onCancelRequested()"
						>
						Annuler
					</button>
				</div>
			</div>
		</div>
	</form>
</bootstrap-popup>